import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
    selector: '[appAutocapitalizeall]',
    standalone: false
})
export class AutocapitalizeallDirective {

  constructor(private el: ElementRef) { }
  
  @HostListener('keydown') onKeyDown() {
    
    if (this.el.nativeElement.value) {
      let arr = this.el.nativeElement.value
      arr = arr.toUpperCase();
      this.el.nativeElement.value = arr;
   }
  }
}
